<template>
  <v-app id="adminApp">
    <header-item />

    <v-content>
      <v-container>
        <v-row
          dense
          align="center"
          max-width="100"
        >
          <v-col
            cols="12"
            sm="12"
            md="12"
            align="center"
          >
            <h2>クラウドフォルダー 初回登録</h2>
          </v-col>
        </v-row>
        
        <v-stepper 
          v-model="e1"
        >
          <v-stepper-header>
            <template v-for="n in stepDef">
              <v-stepper-step
                :key="`${n.index}-step`"
                :complete="e1 > n.index"
                :step="n.index"
              >
                <!-- ステッパータイトルは画面の横幅が最大サイズ以上なら表示 -->
                <span
                  v-if="$vuetify.breakpoint.xl"
                >
                  {{ n.title }}
                </span>
              </v-stepper-step>
  
              <v-divider
                v-if="n.index !== stepDef.length"
                :key="n.index"
              />
            </template>
          </v-stepper-header>
          <v-stepper-items>
            <template v-for="n in stepDef">
              <v-stepper-content
                :key="`${n.index}-step`"
                :step="n.index"
              >
                <div v-if="n.index == 1">
                  <!-- 利用規約 -->
                  <terms-of-service
                    ref="TermsOfService"
                    :index="Number(`${n.index}`)"
                    :user-type="Number(`${Constant.UserType.Host}`)"
                    :disp-top-link-flg="true"
                    @termsOfServiceClickNext="setTermsOfServiceResult($event, termsOfServiceResult)"
                  />
                </div>
                <div v-if="n.index == 2">
                  <v-card
                    color="lighten-1"
                    flat
                  >
                    <v-row
                      dense
                      max-width="100"
                      align="center"
                    >
                      <!-- お客様番号 -->
                      <v-col
                        cols="12"
                        xs="12"
                        sm="12"
                        md="12"
                        lg="1"
                        xl="1"
                      />
                      <v-col
                        cols="12"
                        xs="12"
                        sm="12"
                        md="12"
                        lg="2"
                        xl="2"
                      >
                        <span>
                          お客様番号<required-mark />
                        </span>
                      </v-col>
                      <v-col
                        cols="12"
                        xs="12"
                        sm="12"
                        md="12"
                        lg="6"
                        xl="6"
                      >
                        <v-text-field
                          v-model="weplatCuno"
                          required
                          counter="10"
                          maxlength="10"
                          :rules="[v => !!v || &quot;お客様番号は必須です&quot;]"
                          hint="「マイページ」のお客様番号を入力してください。"
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        xs="12"
                        sm="12"
                        md="12"
                        lg="3"
                        xl="3"
                      />
                      <!-- パスワード -->
                      <v-col
                        cols="12"
                        xs="12"
                        sm="12"
                        md="12"
                        lg="1"
                        xl="1"
                      />
                      <v-col
                        cols="12"
                        xs="12"
                        sm="12"
                        md="12"
                        lg="2"
                        xl="2"
                      >
                        <span>
                          パスワード<required-mark />
                        </span>
                      </v-col>
                      <v-col
                        cols="12"
                        xs="12"
                        sm="12"
                        md="12"
                        lg="6"
                        xl="6"
                      >
                        <v-text-field
                          v-model="weplatPass"
                          required
                          counter="boolean"
                          :rules="[v => !!v || &quot;パスワードは必須です&quot;]"
                          type="password"
                          hint="「マイページ」のパスワードを入力してください。"
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        xs="12"
                        sm="12"
                        md="12"
                        lg="3"
                        xl="3"
                      />
                      <!-- ログイン -->
                      <v-col
                        cols="12"
                        align="center"
                      >
                        <v-btn
                          color="primary"
                          :loading="loading"
                          :disabled="loading"
                          @click="nextStepCheck(Number(`${n.index}`));"
                        >
                          ログイン
                        </v-btn>
                      </v-col>
                      <!-- わすれた場合 -->
                      <v-col
                        cols="12"
                        align="center"
                      >
                        <a
                          href="https://myoen.epson.jp/customers/SC1119Z.jsp"
                          target="_blank"
                          rel="noopener"
                        >
                          お客様番号・パスワードがご不明の場合はこちら
                        </a>
                      </v-col>
                      <v-col
                        cols="12"
                        align="center"
                      >
                        <a
                          href="/"
                        >
                          トップページへ戻る
                        </a>
                      </v-col>
                    </v-row>
                  </v-card>
                </div>
                <div v-if="n.index == 3">
                  <v-form
                    ref="userInfoInput"
                    v-model="valid"
                    lazy-validation
                    @submit.prevent
                  >
                    <v-card
                      color="lighten-1"
                      flat
                    >
                      <v-row
                        dense
                        max-width="100"
                      >
                        <!-- ユーザーID -->
                        <v-col
                          cols="12"
                          xs="12"
                          sm="12"
                          md="12"
                          lg="1"
                          xl="1"
                        />
                        <v-col
                          cols="12"
                          xs="12"
                          sm="12"
                          md="12"
                          lg="2"
                          xl="2"
                        >
                          <span>
                            ユーザーID<required-mark />
                          </span>
                        </v-col>
                        <v-col
                          cols="12"
                          xs="12"
                          sm="12"
                          md="12"
                          lg="6"
                          xl="6"
                        >
                          <v-text-field
                            v-model="userId"
                            required
                            counter="48"
                            maxlength="48"
                            :rules="[v => (v && v.length>= 4) || &quot;ユーザーIDは4文字以上必須です&quot;,
                                     v => /^[a-zA-Z0-9-_.]+$/.test(v) || 'ユーザーIDは半角英数字と記号-_.のみ利用できます']"
                            hint="ユーザーIDを作成します。作成するユーザーIDを入力してください。"
                          />
                        </v-col>
                        <v-col
                          cols="12"
                          xs="12"
                          sm="12"
                          md="12"
                          lg="3"
                          xl="3"
                        />
                        <!-- 担当者名 -->
                        <v-col
                          cols="12"
                          xs="12"
                          sm="12"
                          md="12"
                          lg="1"
                          xl="1"
                        />
                        <v-col
                          cols="12"
                          xs="12"
                          sm="12"
                          md="12"
                          lg="2"
                          xl="2"
                        >
                          <span>
                            担当者名<required-mark />
                          </span>
                        </v-col>
                        <v-col
                          cols="12"
                          xs="12"
                          sm="12"
                          md="12"
                          lg="6"
                          xl="6"
                        >
                          <v-text-field
                            v-model="userName"
                            required
                            counter="12"
                            maxlength="12"
                            :rules="[v => !!v || &quot;担当者名は必須です&quot;]"
                            hint="担当者名を入力してください。担当者名はデータ共有先の取引先様にも表示されます。"
                          />
                        </v-col>
                        <v-col
                          cols="12"
                          xs="12"
                          sm="12"
                          md="12"
                          lg="3"
                          xl="3"
                        />
                        <!-- メールアドレス -->
                        <v-col
                          cols="12"
                          xs="12"
                          sm="12"
                          md="12"
                          lg="1"
                          xl="1"
                        />
                        <v-col
                          cols="12"
                          xs="12"
                          sm="12"
                          md="12"
                          lg="2"
                          xl="2"
                        >
                          <span>
                            メールアドレス<required-mark />
                          </span>
                        </v-col>
                        <v-col
                          cols="12"
                          xs="12"
                          sm="12"
                          md="12"
                          lg="6"
                          xl="6"
                        >
                          <v-text-field
                            v-model="mailAddress"
                            required
                            counter="256"
                            maxlength="256"
                            :rules="[v => !!v || &quot;メールアドレスは必須です&quot;]"
                            hint="「no-reply@wd.weplat.epson.jp」からメールが届きます。受信先で迷惑メールフィルタを設定している場合には、このメールアドレスの受信を許可してください。"
                          />
                        </v-col>
                        <v-col
                          cols="12"
                          xs="12"
                          sm="12"
                          md="12"
                          lg="3"
                          xl="3"
                        />
                        <!-- パスワード -->
                        <v-col
                          cols="12"
                          xs="12"
                          sm="12"
                          md="12"
                          lg="1"
                          xl="1"
                        />
                        <v-col
                          cols="12"
                          xs="12"
                          sm="12"
                          md="12"
                          lg="2"
                          xl="2"
                        >
                          <span>
                            パスワード<required-mark />
                          </span>
                        </v-col>
                        <v-col
                          cols="12"
                          xs="12"
                          sm="12"
                          md="12"
                          lg="6"
                          xl="6"
                        >
                          <create-password-field ref="CreatePasswordField" />
                        </v-col>
                        <v-col
                          cols="12"
                          xs="12"
                          sm="12"
                          md="12"
                          lg="3"
                          xl="3"
                        />
                        <!-- パスワード確認 -->
                        <v-col
                          cols="12"
                          xs="12"
                          sm="12"
                          md="12"
                          lg="1"
                          xl="1"
                        />
                        <v-col
                          cols="12"
                          xs="12"
                          sm="12"
                          md="12"
                          lg="2"
                          xl="2"
                        >
                          <span>
                            パスワード確認<required-mark />
                          </span>
                        </v-col>
                        <v-col
                          cols="12"
                          xs="12"
                          sm="12"
                          md="12"
                          lg="6"
                          xl="6"
                        >
                          <password-field ref="PasswordField" />
                        </v-col>
                        <v-col
                          cols="12"
                          xs="12"
                          sm="12"
                          md="12"
                          lg="3"
                          xl="3"
                        />
                        <!-- ワンタイムパスワード認証 -->
                        <v-col
                          cols="12"
                          xs="12"
                          sm="12"
                          md="12"
                          lg="1"
                          xl="1"
                        />
                        <v-col
                          cols="12"
                          xs="12"
                          sm="12"
                          md="12"
                          lg="2"
                          xl="2"
                        >
                          <span>ワンタイムパスワード認証</span>
                        </v-col>
                        <v-col
                          cols="12"
                          xs="12"
                          sm="12"
                          md="6"
                          lg="3"
                          xl="3"
                        >
                          <v-checkbox
                            v-model="mfaflg"
                            :ripple="false"
                            :label="`ワンタイムパスワード認証を有効にする(スマートフォン必須)`"
                          />
                        </v-col>
                        <v-col
                          cols="12"
                          xs="12"
                          sm="12"
                          md="6"
                          lg="3"
                          xl="3"
                          align="left"
                        >
                          <mfa-description />
                        </v-col>
                        <v-col
                          cols="12"
                          xs="12"
                          sm="12"
                          md="12"
                          lg="3"
                          xl="3"
                        />
                        <!-- 登録 -->
                        <v-col
                          cols="12"
                          align="center"
                        >
                          <v-btn
                            color="primary"
                            @click="nextStepCheck(Number(`${n.index}`));"
                          >
                            登録
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-form>
                </div>
                <div v-if="n.index == 4">
                  <v-card
                    color="lighten-1"
                    flat
                  >
                    <v-row
                      dense
                      max-width="100"
                    >
                      <!-- 確認キー確認メッセージ -->
                      <v-col
                        cols="12"
                        align="center"
                      >
                        <span>
                          管理者ユーザーの仮登録が完了しました。登録したメールアドレスへ確認キーを送信しましたので、入力してください。
                        </span>
                      </v-col>
                      <!-- 確認キー -->
                      <v-col
                        cols="12"
                        xs="12"
                        sm="12"
                        md="12"
                        lg="1"
                        xl="1"
                      />
                      <v-col
                        cols="12"
                        xs="12"
                        sm="12"
                        md="12"
                        lg="2"
                        xl="2"
                      >
                        <span>
                          確認キー<required-mark />
                        </span>
                      </v-col>
                      <v-col
                        cols="12"
                        xs="12"
                        sm="12"
                        md="12"
                        lg="6"
                        xl="6"
                      >
                        <v-text-field
                          v-model="confCode"
                          required
                          counter="6"
                          maxlength="6"
                          :rules="[v => !!v || &quot;確認キーは必須です&quot;]"
                          hint="メールアドレスに送信したメール内に記載されている確認キーを入力してください"
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        xs="12"
                        sm="12"
                        md="12"
                        lg="3"
                        xl="3"
                      />
                      <!-- 確認キーを送信 -->
                      <v-col
                        cols="12"
                        align="center"
                      >
                        <v-btn
                          color="primary"
                          @click="nextStepCheck(Number(`${n.index}`));"
                        >
                          確認キーを送信
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-card>
                </div>
                <div v-if="n.index == 5">
                  <!-- ワンタイムパスワード認証初期設定画面-->
                  <mfa-setting
                    ref="MfaSetting"
                    :index="Number(`${n.index}`)"
                    :user-id="userId"
                    :user-pass-cf="userPassCf"
                    :mfaflg="mfaflg"
                    :mobile-flg="mobileFlg"
                    @clickNext="setMfaOnetimepass($event, mfaSettingResult)"
                  />
                </div>
                <div v-if="n.index == 6">
                  <v-card
                    color="lighten-1"
                    flat
                  >
                    <v-row
                      dense
                      max-width="100"
                    >
                      <v-col
                        cols="12"
                        align="center"
                      >
                        <span>
                          管理者ユーザー作成が完了しました。ログインが可能になります。
                        </span>
                      </v-col>
                      <v-col
                        cols="12"
                        align="center"
                      >
                        <v-btn
                          color="primary"
                          @click="nextStepCheck(Number(`${n.index}`));"
                        >
                          ログイン画面へ
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-card>
                </div>
              </v-stepper-content>
            </template>
          </v-stepper-items>
        </v-stepper>
      </v-container>
    </v-content>
    <msg-dlg ref="MsgDlg" />
  </v-app>
</template>

<script>

import HeaderItem from './HeaderItem.vue'
import Amplify, {isMobile, Constant, RestApiUtil, Logger} from '../amplify_com.js';
import MsgDlg from './MsgDlg.vue';
import RequiredMark from './RequiredMark.vue';
import CreatePasswordField from './CreatePasswordField.vue';
import PasswordField from './PasswordField.vue';
import MfaDescription from './MfaDescription.vue';
import MfaSetting from './MfaSetting';
import TermsOfService from './TermsOfService';

export default {  
  components: {
    'header-item': HeaderItem,
    'msg-dlg': MsgDlg,
    'required-mark': RequiredMark,
    'create-password-field': CreatePasswordField,
    'password-field': PasswordField,
    'mfa-description': MfaDescription,
    'mfa-setting': MfaSetting,
    'terms-of-service': TermsOfService,
  },
  data: () => ({
    Constant :Constant, // template内で定数クラスを使用するため
    // ステップ定義
    stepDef: [
      { 
        index : 1,
        title : '利用規約同意', 
        checkFunc: async function(adminApp){
            return adminApp.agreeflg;
        },
        okFunc: async function(adminApp, now_index){
          // チェックOK時の処理
          adminApp.$refs.MsgDlg.showInfo('利用規約に同意しました。');

          // 次へ
          adminApp.nextStep (now_index + 1);
        },
      },
      { 
        index : 2,
        title : 'お客様番号ログイン', 
        checkFunc: async function(adminApp){
          // WeplatログインAPI実行
          adminApp.wpTmpPass = null;
          adminApp.loading = true;
          await RestApiUtil.PostWeplatToken(adminApp.weplatCuno, adminApp.weplatPass).then(weplatToken => {
            // 次の遷移先urlを取得できたなら遷移
            if(weplatToken.token){
              adminApp.wpTmpPass = weplatToken.token;
              adminApp.weplatCuno = adminApp.weplatCuno + '000';
              adminApp.mailAddress = weplatToken.mail_address;
            }
          }).catch(error => {
              Logger.log(error);
              adminApp.wpTmpPass = null;
          });
          // WeplatログインAPI判定
          if(adminApp.wpTmpPass){
            adminApp.loading = false;
            return true;
          } else {
            adminApp.$refs.MsgDlg.showError('お客様番号によるログインに失敗しました');
            adminApp.loading = false;
            return false;
          }
        },
        okFunc: function(adminApp, now_index){
          // チェックOK時の処理
          adminApp.$refs.MsgDlg.showSuccess('お客様番号によるログインに成功しました');
          // 次へ
          adminApp.nextStep (now_index + 1);
        },
      },
      { 
        index : 3,
        title : '管理者ユーザー情報入力', 
        checkFunc: async function(adminApp){
          // コンポーネントからパスワード取得 リストレンダリングされているので[0]が必要
          adminApp.userPass = adminApp.$refs.CreatePasswordField[0].getPassword();
          adminApp.userPassCf = adminApp.$refs.PasswordField[0].getPassword();

          //バリデーション（validateはrulesが設定されている項目だけを囲う）
          if(!adminApp.$refs.userInfoInput[0].validate()){
            if(!adminApp.userId){
              adminApp.$refs.MsgDlg.showError('ユーザーIDを入力してください');
              return false;
            }

            if(!adminApp.userName){
              adminApp.$refs.MsgDlg.showError('担当者名を入力してください');
              return false;
            }

            if(!adminApp.mailAddress){
              adminApp.$refs.MsgDlg.showError('メールアドレスを入力してください');
              return false;
            }
            return false;
          }

          if(!adminApp.userPass){
            adminApp.$refs.MsgDlg.showError('パスワードを入力してください');
            return false;
          }

          if(!adminApp.userPassCf){
            adminApp.$refs.MsgDlg.showError('パスワード確認を入力してください');
            return false;
          }

          if(adminApp.userPass === adminApp.userId){
            adminApp.$refs.MsgDlg.showError('ユーザーIDと同じパスワードは入力不可です。');
            return false;
          }

          if(adminApp.userPass !== adminApp.userPassCf){
            adminApp.$refs.MsgDlg.showError('パスワードとパスワード確認には同じパスワードを入力してください');
            return false;
          }

          return true;
        },
        okFunc: function(adminApp, now_index){
            adminApp.$refs.MsgDlg.showOkCancel(null, '入力された情報でユーザーを作成します。\r\n本当によろしいですか？')
            .then(function(okCancelResult) {
              if(okCancelResult){
                // チェックOK時の処理
                Amplify.Auth.signUp({
                    'username' : adminApp.userId,
                    'password' : adminApp.userPassCf,
                    attributes: {
                        'email' : adminApp.mailAddress, 
                        'custom:wp_custno' : adminApp.weplatCuno,
                        'custom:wp_tmp_pass' : adminApp.wpTmpPass,
                        'custom:mfa_type' : adminApp.mfaflg ? Constant.UserMfa.On : Constant.UserMfa.Off,
                        'custom:auth_type' : String(Constant.UserAuthType.Admin),
                        'custom:disp_name' : adminApp.userName,
                        'custom:input_user_name' : adminApp.userId,
                    },
                    validationData: []
                }).then(() => {
                  adminApp.$refs.MsgDlg.showSuccess('管理者ユーザーの仮登録に成功しました。');
                  // 次へ
                  adminApp.nextStep(now_index + 1);
                }).catch(err => {
                  adminApp.$refs.MsgDlg.showModalError(Amplify.GetJaErrMsg(err));
                });
              }
            });
        },
      },
      { 
        index : 4,
        title : 'メールアドレス確認', 
        checkFunc: async function(adminApp){
          if(!adminApp.confCode){
            adminApp.$refs.MsgDlg.showError('確認キーを入力してください');
            return false;
          }
          return true;
        },
        okFunc: function(adminApp, now_index){
          // チェックOK時の処理
          Amplify.Auth.confirmSignUp(
              adminApp.userId,
              adminApp.confCode
          ).then(() => {
            adminApp.$refs.MsgDlg.showSuccess('メールアドレス確認に成功しました。');
            if(adminApp.mfaflg){
              // MFA設定画面 初期化
              adminApp.$refs.MfaSetting[0].init();
            }
            // 次へ
            adminApp.nextStep(now_index + 1);
          }).catch(err => {
            adminApp.$refs.MsgDlg.showModalError(Amplify.GetJaErrMsg(err));
          });
        },
      },
      { 
        index : 5,
        title : 'ワンタイムパスワード認証 初期設定', 
        checkFunc: async function(adminApp){
          // mfa認証あり ワンタイムパスワード入力なし
          if(adminApp.mfaflg && !adminApp.mfaOnetimepass){
            adminApp.$refs.MsgDlg.showError('ワンタイムパスワードを入力してください');
            adminApp.$refs.MfaSetting[0].setLoadingOneTime();
            return false;
          }

          return true;
        },
        okFunc: function(adminApp, now_index){

          // mfa認証あり
          if(adminApp.mfaflg ){
            Amplify.Auth.signIn(
              {
                  username : adminApp.userId,
                  password : adminApp.userPassCf,
                  validationData: {
                    input_username: adminApp.userId,
                  },
              }
            ).then(user => {
              let _user = user;
              Amplify.Auth.verifyTotpToken(
                _user,
                adminApp.mfaOnetimepass,
              ).then(() => {
                Amplify.Auth.setPreferredMFA(
                  _user,
                  'TOTP'
                ).then(() => {
                  adminApp.$refs.MsgDlg.showModalSuccess('ワンタイムパスワード認証に成功しました。');
                  // 次へ
                  adminApp.nextStep(now_index + 1);
                  adminApp.$refs.MfaSetting[0].setLoadingOneTime();
                }).catch(err => {
                  adminApp.$refs.MsgDlg.showModalError(Amplify.GetJaErrMsg(err));
                  adminApp.$refs.MfaSetting[0].setLoadingOneTime();
                });
              }).catch(err => {
                adminApp.$refs.MsgDlg.showModalError(Amplify.GetJaErrMsg(err));
                adminApp.$refs.MfaSetting[0].setLoadingOneTime();
              });
            }).catch(err => {
              adminApp.$refs.MsgDlg.showModalError(Amplify.GetJaErrMsg(err));
              adminApp.$refs.MfaSetting[0].setLoadingOneTime();
            });
          } else {
            // 次へ
            adminApp.nextStep(now_index + 1);
            adminApp.$refs.MfaSetting[0].setLoadingOneTime();
          }
        },
      },
      { 
        index : 6,
        title : '完了', 
        checkFunc: async function(){
          return true;
        },
        okFunc: function(adminApp, now_index){
          // 次へ
          adminApp.nextStep(now_index + 1);
        },
      },
    ],
    e1: 1,
    steps: 6,
    agreeflg: false,
    weplatCuno: '',
    weplatPass: '',
    wpTmpPass: '',
    userId: '', 
    userName: '',
    mailAddress: '',
    userPass: '',
    userPassCf: '',
    mfaflg: false, 
    confCode: '',
    mfaOnetimepass: '',
    mobileFlg: isMobile.any,
    loading: false,
    valid: null,
    termsOfServiceResult: null,
    mfaSettingResult: null,
  }),
  watch: {
    steps (val) {
      if (this.e1 > val) {
        this.e1 = val
      }
    },
    userId(val) {
      this.$refs.CreatePasswordField[0].setUserId(val);
      if(val === this.$refs.CreatePasswordField[0].getPassword()){
        this.$refs.MsgDlg.showError('ユーザーIDと同じパスワードは入力不可です。');
      }
    },
  },
  created: function () {
    // 念のため、サインしているならサインアウト
    Amplify.Auth.currentUserPoolUser().then(() => {
        Amplify.Auth.signOut();
    }).catch(err => {
      // エラー発生しても無視
      Logger.log(err);
    });
  },
  mounted() {
    //戻るボタン無効化
    history.pushState(null, null, null);
    window.addEventListener("popstate", function () {
      history.pushState(null, null, null);
      return;
    });
  },
  methods: {
    nextStepCheck : async function(n) {
      var curDef = this.stepDef[n-1];
      if(await curDef.checkFunc(this)){
        curDef.okFunc(this, n);
      }
    },
    nextStep (n) {
      if (n === this.steps + 1) {
        // 次のステップはないのでログイン画面へ遷移
        this.$router.push({ path: "/" }, () => {}, () => {});
      } else {
        this.e1 = n
      }
    },
    // 利用規約画面からのコールバック
    setTermsOfServiceResult(termsOfServiceResult){
      this.agreeflg = termsOfServiceResult.agreeflg;
      this.nextStepCheck(termsOfServiceResult.index);
    },
    // MFA初期設定画面からのコールバック
    setMfaOnetimepass(mfaSettingResult){
      this.mfaOnetimepass = mfaSettingResult.mfaOnetimepass;
      this.nextStepCheck(mfaSettingResult.index);
    },
  }
};
</script>

<style>
.v-application--wrap {min-height:0;}
</style>